import { useEffect, useRef } from "react";

export default function useUpdateEffect(effect, dependenciesObject) {
  const isFirstRender = useRef(true);
  const previousDeps = useRef({});

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      previousDeps.current = dependenciesObject;
      return;
    }

    const changedDeps = Object.entries(dependenciesObject).reduce(
      (acc, [key, value]) => {
        if (previousDeps.current[key] !== value) {
          acc.push({
            name: key,
            prev: previousDeps.current[key],
            current: value,
          });
        }
        return acc;
      },
      []
    );

    if (changedDeps.length > 0) {
      effect(changedDeps); // Pass changed dependencies info
    }

    previousDeps.current = dependenciesObject;
  }, Object.values(dependenciesObject));
}
